import { Box, Grid, Typography, Chip, Stack, Divider } from "@mui/material"
import { useNavigate } from "react-router-dom";
import FechaFunction from "../../function/FechaFunction"
import TextEstadoTicketIndv from "../text/TextEstadoTicketIndv"
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BusinessIcon from '@mui/icons-material/Business';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const CardViewTicket = ({item,onCloseModal,textSearch}) => {
    const navigate = useNavigate();
    const highlightText = (text, search) => {
        if (!search || !text) return text;
        const parts = String(text).split(new RegExp(`(${search})`, 'gi'));
        return (
            <>
                {parts.map((part, index) => 
                    part.toLowerCase() === search.toLowerCase() ? (
                        <Box
                            key={index}
                            component="span"
                            sx={{
                                backgroundColor: '#fff59d',
                                color: '#000',
                                fontWeight: 700,
                                padding: '1px 2px',
                                borderRadius: '2px'
                            }}
                        >
                            {part}
                        </Box>
                    ) : (
                        part
                    )
                )}
            </>
        );
    };
    const ticket = item?.ticket || item;
    const clientes = item?.clientes || ticket?.clientes || [];
    const ticketxtratos = item?.ticketxtrato || ticket?.ticketxtrato || [];
    const getPriorityConfig = (priority) => {
        switch(priority?.toUpperCase()) {
            case 'ALTA':
                return { color: '#d32f2f', bg: '#ffebee', icon: <WarningAmberIcon sx={{fontSize: 14}} /> };
            case 'MEDIA':
                return { color: '#f57c00', bg: '#fff3e0', icon: <WarningAmberIcon sx={{fontSize: 14}} /> };
            case 'BAJA':
                return { color: '#388e3c', bg: '#e8f5e9', icon: <CheckCircleOutlineIcon sx={{fontSize: 14}} /> };
            default:
                return { color: '#616161', bg: '#f5f5f5', icon: <CheckCircleOutlineIcon sx={{fontSize: 14}} /> };
        }
    };
    const getStageColor = (stage) => {
        switch(stage) {
            case 'ABIERTO': return '#0364ff';
            case 'CERRADO': return '#6b788e';
            case 'VENCIDO': return '#d32f2f';
            case 'PORVENCER': return '#f57c00';
            case 'VENCEHOY': return '#ff9800';
            default: return '#616161';
        }
    };
    const redirectTk = () =>{
        if(onCloseModal){
            onCloseModal();
        }
        const ticketId = ticket?.id_tk;
        navigate(`/ticket/${ticketId}/nubicom`);
    }
    const onClickNameCliente = (e, cli) => {
        e.stopPropagation();
        if(cli?.cuenta){
            navigate(`/contactos/${cli?.cuenta}/cuenta`);
        }else if(cli?.id_c){
            navigate(`/contactos/${cli?.id_c}/nubicom`);
        }
    }
    const onClickNameServicio = (e, srv) => {
        e.stopPropagation();
        if(srv?.cuentaContratoId_txt){
            navigate(`/servicio/${srv?.cuentaContratoId_txt}/cuenta`);
        }else if(srv?.tratoId_txt){
            navigate(`/pre-servicio/${srv?.tratoId_txt}/nubicom`);
        }else if(srv?.id_t){
            navigate(`/pre-servicio/${srv?.id_t}/nubicom`);
        }
    }
    const priorityConfig = getPriorityConfig(ticket?.prioridad_tk);
    return (
        <Box
            sx={{
                background: '#fff',
                border: '1px solid #e0e0e0',
                borderLeft: `3px solid ${getStageColor(ticket?.estado_tk)}`,
                borderRadius: '6px',
                mb: 1,
                transition: 'all 0.15s ease',
                '&:hover':{
                    background: '#fafafa',
                    cursor: 'pointer',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                    borderLeftWidth: '4px'
                }
            }}
            onClick={()=>redirectTk()}
        >
            <Box sx={{px: {xs: 1, sm: 1.5}, py: {xs: 1, sm: 1.2}}}>
                <Grid container spacing={{xs: 1, sm: 1.5}} alignItems='center'>
                    {/* Logo/Avatar - Responsive */}
                    <Grid item xs="auto" display='flex' alignItems='center'>
                        <Box sx={{
                            width: {xs: 36, sm: 40},
                            height: {xs: 36, sm: 40},
                            border: '1.5px solid #e0e0e0',
                            borderRadius: {xs: '6px', sm: '8px'},
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#fafafa'
                        }}>
                            <img
                                src="/img/nubi-cirucular.png"
                                width={32}
                                height={32}
                                alt="Nubicom"
                                style={{width: '100%', height: '100%', objectFit: 'contain', padding: '4px'}}
                            />
                        </Box>
                    </Grid>
                    {/* Main Content - Responsive Layout */}
                    <Grid item xs>
                        <Box display='flex' flexDirection='column' gap={{xs: 0.7, sm: 0.5}}>
                            {/* Línea 1: ID, Título - Responsive */}
                            <Box display='flex' alignItems='flex-start' flexDirection={{xs: 'column', sm: 'row'}} gap={{xs: 0.3, sm: 1}}>
                                <Box display='flex' alignItems='center' gap={0.5} flexWrap='wrap'>
                                    <Typography 
                                        component='span'
                                        sx={{
                                            color: '#1967d2',
                                            fontWeight: 700,
                                            fontSize: {xs: 12, sm: 13},
                                            lineHeight: 1.2
                                        }}
                                    >
                                        #{highlightText(ticket?.id_tk, textSearch)}
                                    </Typography>
                                    <Typography
                                        component='span'
                                        sx={{
                                            color: '#202124',
                                            fontWeight: 600,
                                            fontSize: {xs: 12, sm: 13},
                                            lineHeight: 1.3,
                                            wordBreak: 'break-word'
                                        }}
                                    >
                                        {highlightText(ticket?.titulo_tk, textSearch)}
                                    </Typography>
                                </Box>
                            </Box>
                            {/* Badges en línea separada para mejor responsividad */}
                            <Box display='flex' alignItems='center' gap={0.5} flexWrap='wrap'>
                                <Chip
                                    label={ticket?.stageTicket_tk || 'Sin Stage'}
                                    size="small"
                                    sx={{
                                        height: {xs: 16, sm: 18},
                                        fontSize: {xs: 9, sm: 10},
                                        fontWeight: 600,
                                        backgroundColor: '#e8f0fe',
                                        color: '#1967d2',
                                        '& .MuiChip-label': { px: {xs: 0.7, sm: 1}, py: 0 }
                                    }}
                                />
                                <Chip
                                    icon={priorityConfig.icon}
                                    label={ticket?.prioridad_tk || 'Media'}
                                    size="small"
                                    sx={{
                                        height: {xs: 16, sm: 18},
                                        fontSize: {xs: 9, sm: 10},
                                        fontWeight: 600,
                                        backgroundColor: priorityConfig.bg,
                                        color: priorityConfig.color,
                                        '& .MuiChip-label': { px: {xs: 0.6, sm: 0.8}, py: 0 },
                                        '& .MuiChip-icon': { 
                                            color: priorityConfig.color, 
                                            ml: 0.3,
                                            fontSize: {xs: 11, sm: 12}
                                        }
                                    }}
                                />
                                {ticket?.nomGrupo && (
                                    <Chip
                                        label={ticket.nomGrupo}
                                        size="small"
                                        sx={{
                                            height: {xs: 16, sm: 18},
                                            fontSize: {xs: 9, sm: 10},
                                            fontWeight: 600,
                                            backgroundColor: '#f3e8ff',
                                            color: '#7c3aed',
                                            '& .MuiChip-label': { px: {xs: 0.7, sm: 1}, py: 0 }
                                        }}
                                    />
                                )}
                            </Box>
                            {/* Línea 2: Clientes, Servicios e Info - Responsive y apilable */}
                            <Box display='flex' alignItems='center' gap={{xs: 1, sm: 1.5}} flexWrap='wrap'>
                                {/* Clientes */}
                                {clientes?.length > 0 && (
                                    <Box display='flex' alignItems='center' gap={0.5} sx={{minWidth: 0}}>
                                        <PersonOutlineIcon sx={{fontSize: {xs: 12, sm: 13}, color: '#70757a', flexShrink: 0}} />
                                        <Box display='flex' flexWrap='wrap' gap={0.3} sx={{minWidth: 0}}>
                                            {clientes.map((cli, idx) => (
                                                <Typography
                                                    key={idx}
                                                    component='span'
                                                    onClick={(e) => onClickNameCliente(e, cli)}
                                                    sx={{
                                                        color: '#1967d2',
                                                        fontWeight: 600,
                                                        fontSize: {xs: 10, sm: 11},
                                                        cursor: 'pointer',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        maxWidth: {xs: '120px', sm: 'none'},
                                                        '&:hover': {
                                                            color: '#0d47a1',
                                                            textDecoration: 'underline'
                                                        },
                                                        '&:not(:last-child)::after': {
                                                            content: '", "',
                                                            color: '#70757a'
                                                        }
                                                    }}
                                                >
                                                    {cli?.nombre || cli?.nombreCompleto_c}
                                                </Typography>
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                                {/* Servicios como chips mini */}
                                {(ticketxtratos?.length > 0 || item?.id_t) && (
                                    <Box display='flex' alignItems='center' gap={0.5} flexWrap='wrap'>
                                        <BusinessIcon sx={{fontSize: {xs: 12, sm: 13}, color: '#70757a', flexShrink: 0}} />
                                        {ticketxtratos.map((srv, idx) => (
                                            <Chip
                                                key={idx}
                                                label={srv?.cuentaContratoId_txt ? `#${srv.cuentaContratoId_txt}` : `Pre #${srv.tratoId_txt}`}
                                                size="small"
                                                onClick={(e) => onClickNameServicio(e, srv)}
                                                sx={{
                                                    height: {xs: 16, sm: 18},
                                                    fontSize: {xs: 9, sm: 10},
                                                    fontWeight: 600,
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #dadce0',
                                                    color: '#5f6368',
                                                    cursor: 'pointer',
                                                    '& .MuiChip-label': { px: {xs: 0.6, sm: 0.8}, py: 0 },
                                                    '&:hover': {
                                                        backgroundColor: '#f1f3f4',
                                                        borderColor: '#5f6368'
                                                    }
                                                }}
                                            />
                                        ))}
                                        {item?.id_t && (
                                            <Chip
                                                label={!item?.cuentaContratoId_txt ? `Pre #${item.id_t}` : `#${item.id_t}`}
                                                size="small"
                                                onClick={(e) => onClickNameServicio(e, item)}
                                                sx={{
                                                    height: {xs: 16, sm: 18},
                                                    fontSize: {xs: 9, sm: 10},
                                                    fontWeight: 600,
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #dadce0',
                                                    color: '#5f6368',
                                                    cursor: 'pointer',
                                                    '& .MuiChip-label': { px: {xs: 0.6, sm: 0.8}, py: 0 },
                                                    '&:hover': {
                                                        backgroundColor: '#f1f3f4',
                                                        borderColor: '#5f6368'
                                                    }
                                                }}
                                            />
                                        )}
                                    </Box>
                                )}
                                {(item?.cuentaContratoId_txt || item?.tratoId_txt) && (
                                    <Box display='flex' alignItems='center' gap={0.5} flexWrap='wrap'>
                                        <BusinessIcon sx={{fontSize: {xs: 12, sm: 13}, color: '#70757a', flexShrink: 0}} />
                                            <Chip
                                                key={item?.cuentaContratoId_txt || item?.tratoId_txt}
                                                label={item?.cuentaContratoId_txt ? `#${item.cuentaContratoId_txt}` : `Pre #${item.tratoId_txt}`}
                                                size="small"
                                                onClick={(e) => onClickNameServicio(e, item)}
                                                sx={{
                                                    height: {xs: 16, sm: 18},
                                                    fontSize: {xs: 9, sm: 10},
                                                    fontWeight: 600,
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #dadce0',
                                                    color: '#5f6368',
                                                    cursor: 'pointer',
                                                    '& .MuiChip-label': { px: {xs: 0.6, sm: 0.8}, py: 0 },
                                                    '&:hover': {
                                                        backgroundColor: '#f1f3f4',
                                                        borderColor: '#5f6368'
                                                    }
                                                }}
                                            />
                                    </Box>
                                )}
                                {/* Divider vertical - oculto en móvil */}
                                {(clientes?.length > 0 || ticketxtratos?.length > 0 || item?.id_t) && ticket?.createdAt && (
                                    <Divider
                                        orientation="vertical"
                                        flexItem
                                        sx={{
                                            height: 12,
                                            alignSelf: 'center',
                                            backgroundColor: '#dadce0',
                                            display: {xs: 'none', sm: 'block'}
                                        }}
                                    />
                                )}
                                {/* Info adicional en línea separada en móvil */}
                                <Box
                                    display='flex'
                                    alignItems='center'
                                    gap={{xs: 0.8, sm: 1.5}}
                                    flexWrap='wrap'
                                    sx={{width: {xs: '100%', sm: 'auto'}}}
                                >
                                    {/* Fecha */}
                                    {ticket?.createdAt && (
                                        <Box display='flex' alignItems='center' gap={0.3}>
                                            <AccessTimeIcon sx={{fontSize: {xs: 11, sm: 12}, color: '#70757a'}} />
                                            <Typography sx={{color: '#70757a', fontSize: {xs: 9, sm: 10}, fontWeight: 500, whiteSpace: 'nowrap'}}>
                                                {FechaFunction.format(new Date(ticket.createdAt), 'dd/MM/yy HH:mm')}
                                            </Typography>
                                        </Box>
                                    )}
                                    {ticket?.codCanalNombre_tk && (
                                        <>
                                            <Divider
                                                orientation="vertical"
                                                flexItem
                                                sx={{
                                                    height: 10,
                                                    alignSelf: 'center',
                                                    backgroundColor: '#dadce0',
                                                    display: {xs: 'none', sm: 'block'}
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    color: '#70757a',
                                                    fontSize: {xs: 9, sm: 10},
                                                    fontWeight: 500,
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    maxWidth: {xs: '100px', sm: '150px'}
                                                }}
                                            >
                                                {ticket.codCanalNombre_tk}
                                            </Typography>
                                        </>
                                    )}
                                    {(ticket?.timeElapsed_tk && ticket?.timeElapsed_tk?.length > 10) && (
                                        <>
                                            <Divider
                                                orientation="vertical"
                                                flexItem
                                                sx={{
                                                    height: 10,
                                                    alignSelf: 'center',
                                                    backgroundColor: '#dadce0',
                                                    display: {xs: 'none', sm: 'block'}
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    color: '#70757a',
                                                    fontSize: {xs: 9, sm: 10},
                                                    fontWeight: 500,
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                ⏱ {JSON.parse(ticket.timeElapsed_tk)?.time}
                                            </Typography>
                                        </>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid
                        item
                        xs="auto"
                        display='flex'
                        alignItems='center'
                        sx={{
                            position: {xs: 'absolute', sm: 'relative'},
                            top: {xs: 8, sm: 'auto'},
                            right: {xs: 8, sm: 'auto'}
                        }}
                    >
                        <Box sx={{
                            transform: {xs: 'scale(0.85)', sm: 'scale(0.9)'},
                            transformOrigin: 'right center'
                        }}>
                            <TextEstadoTicketIndv estado={ticket?.estado_tk} cerrado={ticket?.cerrado_tk} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default CardViewTicket